<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ title }}</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <table width="100%">
        <tr>
          <td><strong>Total opkrævet:</strong></td>
          <td class="align-right padding--bottom-m">
            @if (serviceaftale.kunde?.kundetype.id == 1) {
              <span>
                <strong>{{ afregning.beloebMedMoms | dkCurrency }}</strong>
                <br />
                <small class="grey-light">Inkl. moms</small>
              </span>
            }
            @if (serviceaftale.kunde?.kundetype.id == 2) {
              <span>
                {{ afregning.beloebExclMoms | dkCurrency }}
                <br />
                <small class="grey-light">Ekskl. moms</small>
              </span>
            }
          </td>
        </tr>
        <tr>
          <td>Kreditering:</td>
          <td class="align-right">
            @if (serviceaftale.kunde?.kundetype.id == 1) {
              <span>
                {{ afregning.beloebMedMoms * -1 | dkCurrency }}
                <br />
                <small class="grey-light">Inkl. moms</small>
              </span>
            }
            @if (serviceaftale.kunde?.kundetype.id == 2) {
              <span>
                {{ afregning.beloebExclMoms * -1 | dkCurrency }}
                <br />
                <small class="grey-light">Ekskl. moms</small>
              </span>
            }
          </td>
        </tr>
      </table>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline" class="mdc-textarea-fix">
        <mat-label>Fakturanote</mat-label>

        <textarea id="note" placeholder="Bemærkning..." formControlName="note" rows="2" matInput type="text"></textarea>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-slide-toggle color="primary" formControlName="nyFaktura">
        Send ny {{ afregning.opkraevningScope == opkraevningScopePartner ? 'partnerafregning' : 'faktura' }}
      </mat-slide-toggle>
    </div>
    @if (afregning.opkraevningScope != opkraevningScopePartner) {
      <div class="form-row">
        <mat-slide-toggle
          color="primary"
          formControlName="partnerkorrektion"
          [disabled]="data.harPartnerTilbagefoersel || !data.harPartnerAfregning"
          >
          Partner korrektion
        </mat-slide-toggle>
        <mat-error>
          @if (data.harPartnerTilbagefoersel) {
            <span>Partner afregning er allerede tilbageført</span>
          }
          @if (!data.harPartnerAfregning) {
            <span>Partner afregning mangler</span>
          }
        </mat-error>
      </div>
    }
  </form>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">{{ title }}</button>
</div>
